import script from "./LevelPlayChoiceModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LevelPlayChoiceModal.vue?vue&type=script&setup=true&lang=js"

import "./LevelPlayChoiceModal.vue?vue&type=style&index=0&id=05d8f41a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05d8f41a"]])

export default __exports__